<p-toast></p-toast>
<div class="app-verification-container">
    <p-card styleClass="p-card-shadow">
        <!-- <h5 class="mt-0">Farmer Application Details</h5> -->
        <div class="card dashboardTable">
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                </ng-template>
                <ng-template pTemplate="right">
                    <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                        class="p-button-help"></button>
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}"
                        icon="pi pi-refresh" class="p-button-info ml-3"></button>
                    <p-menu #menu [popup]="true" [model]="canalAndTubewellItems"></p-menu>
                </ng-template>

            </p-toolbar>
            <p-table #yearwiseProgressTable [value]="WaterSoucreListData" [rows]="10" [paginator]="true"
                [globalFilterFields]="['Source_Name','Verified_Apps','Verified_Area_Count','Under_Process_of_Installation',
                'Assistance_Disbursed','Area', 'Disbursed_Amount','Noof_Benficiaries']" responsiveLayout="scroll"
                [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" sortField="Source_Name" [sortOrder]="1">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'MICRO_IRRIGATION_SYSTEM' | translate}}
                        </h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="yearwiseProgressTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>

                        </th> -->
                        <!-- <th></th> -->
                        <th pSortableColumn="Source_Name">{{'WATER_SOURCE' | translate}}
                            <p-columnFilter type="text" field="Source_Name" display="menu"></p-columnFilter>
                            <p-sortIcon field="Source_Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Verified_Apps">{{'APPLICATION_VERIFIED' | translate}}
                            <p-columnFilter type="text" field="Verified_Apps" display="menu"></p-columnFilter>
                            <p-sortIcon field="Verified_Apps"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Verified_Area_Count">{{'MI_AREA_IN_ACRE' | translate}}
                            <p-columnFilter type="text" field="Verified_Area_Count" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Verified_Area_Count"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Under_Process_of_Installation">{{'APPLICATION_INSTALLATION' | translate}}
                            <p-columnFilter type="text" field="Under_Process_of_Installation" display="menu"></p-columnFilter>
                            <p-sortIcon field="Under_Process_of_Installation"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Assistance_Disbursed">{{'ASSISTANCE_DISBURSED' | translate}}
                            <p-columnFilter type="text" field="Assistance_Disbursed" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Assistance_Disbursed"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Area">{{'AREA_IN_ACRE' | translate}}
                            <p-columnFilter type="text" field="Area" display="menu"></p-columnFilter>
                            <p-sortIcon field="Area"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Disbursed_Amount">{{'AMOUNT_IN_LAKH' | translate}}
                            <p-columnFilter type="text" field="Disbursed_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="Disbursed_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Noof_Benficiaries">{{'NOOF_BENEFICIARY' | translate}}
                            <p-columnFilter type="text" field="Noof_Benficiaries" display="menu"></p-columnFilter>
                            <p-sortIcon field="Noof_Benficiaries"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                        <td>{{product?.Source_Name}}</td>
                        <td>{{product?.Verified_Apps}}</td>
                        <td>{{product?.Verified_Area_Count}}</td>
                        <td>{{product?.Under_Process_of_Installation}}</td>
                        <td>{{product?.Assistance_Disbursed}}</td>
                        <td>{{product?.Area}}</td>
                        <td>{{product?.Disbursed_Amount}}</td>
                        <td>{{product?.Noof_Benficiaries}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex  justify-content-between flex-column ">
                        <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{WaterSoucreListData ? WaterSoucreListData.length : 0 }}
                            {{'VERIFICATION_APPLICATIONS_ADDED'| translate}}.
                        </p>
                    </div>
                </ng-template>
            </p-table>
        </div>
        <div class="card dashboardTable">
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                </ng-template>
                <ng-template pTemplate="right">
                    <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                        class="p-button-help"></button>
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}"
                        icon="pi pi-refresh" class="p-button-info ml-3"></button>
                    <p-menu #menu [popup]="true" [model]="districtConstituencyItems"></p-menu>
                </ng-template>

            </p-toolbar>

            <p-table #yearwiseProgress2Table [value]="disctrictConsistenceWiseData" [rows]="10" [paginator]="true"
                [globalFilterFields]="['Source_id','District','Constituency','Application_recevied','Area','Approved', 'Verified_Area_Count',
                     'Incomplete_Area_count', 'Incomplete', 'Rejected', 'Pending', 'Estimate_Created','Estimate_Approved',
                      'Billsof_Quantity_Uploaded', 'PhysicalVerificationCompleted', 'Assistance_Disbursed', 'Assistance_Disbursed_Area' , 'Assistance_Disbursed_Amount', 'Noofbeneficiaries']"
                responsiveLayout="scroll" [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" sortField="District" [sortOrder]="1">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'DRILL_DOWN_WILL_LEAD_TO_DISTRICT'| translate}}
                        </h5>
                        <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="yearwiseProgress2Table.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH'| translate}}" />
                            </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="Source_id">{{'SI'| translate}}
                            <p-columnFilter type="text" field="Source_id" display="menu"></p-columnFilter>
                            <p-sortIcon field="Source_id"></p-sortIcon>
                        </th>
                        <th pSortableColumn="District">{{'DISTRICT'| translate}}
                            <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                            <p-sortIcon field="District"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Constituency">{{'CONSTITUENCY'| translate}}
                            <p-columnFilter type="text" field="Constituency" display="menu"></p-columnFilter>
                            <p-sortIcon field="Constituency"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Application_recevied">{{'APP_RECEIVED'| translate}}
                            <p-columnFilter type="text" field="Application_recevied" display="menu"></p-columnFilter>
                            <p-sortIcon field="Application_recevied"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Area">{{'AREA'| translate}}
                            <p-columnFilter type="text" field="Area" display="menu"></p-columnFilter>
                            <p-sortIcon field="Area"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Approved">{{'VERIFIED_APP'| translate}}
                            <p-columnFilter type="text" field="Approved" display="menu"></p-columnFilter>
                            <p-sortIcon field="Approved"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Verified_Area_Count">{{'AREA'| translate}}
                            <p-columnFilter type="text" field="Verified_Area_Count" display="menu"></p-columnFilter>
                            <p-sortIcon field="Verified_Area_Count"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Incomplete">{{'INCOMPLETE_APP'| translate}}
                            <p-columnFilter type="text" field="Incomplete" display="menu"></p-columnFilter>
                            <p-sortIcon field="Incomplete"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Rejected">{{'REJECTED_APP'| translate}}
                            <p-columnFilter type="text" field="Rejected" display="menu"></p-columnFilter>
                            <p-sortIcon field="Rejected"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Pending">{{'PENDING_APP'| translate}}
                            <p-columnFilter type="text" field="Pending" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Pending"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Estimate_Created">{{'ESTIMATE_CREATED'| translate}}
                            <p-columnFilter type="text" field="Estimate_Created" display="menu"></p-columnFilter>
                            <p-sortIcon field="Estimate_Created"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Estimate_Approved">{{'ESTIMATE_APPROVED'| translate}}
                            <p-columnFilter type="text" field="Estimate_Approved" display="menu"></p-columnFilter>
                            <p-sortIcon field="Estimate_Approved"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Billsof_Quantity_Uploaded">{{'BILLS_OF_QUANTITY'| translate}}
                            <p-columnFilter type="text" field="Billsof_Quantity_Uploaded" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Billsof_Quantity_Uploaded"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Physical_Verification_Completed">{{'PHYSICAL_VERIFICATION_COMPLETED'|
                            translate}}
                            <p-columnFilter type="text" field="Physical_Verification_Completed" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Physical_Verification_Completed"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Assistance_Disbursed">{{'ASSISTANCE_DISBURSED'| translate}}
                            <p-columnFilter type="text" field="Assistance_Disbursed" display="menu"></p-columnFilter>
                            <p-sortIcon field="Assistance_Disbursed"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Assistance_Disbursed_Area">{{'AREA'| translate}}
                            <p-columnFilter type="text" field="Assistance_Disbursed_Area" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Assistance_Disbursed_Area"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Assistance_Disbursed_Amount">{{'AMOUNT'| translate}}
                            <p-columnFilter type="text" field="Assistance_Disbursed_Amount" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Assistance_Disbursed_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="NoOf_Benficiary">{{'NOOF_BENEFICIARY'| translate}}
                            <p-columnFilter type="text" field="NoOf_Benficiary" display="menu"></p-columnFilter>
                            <p-sortIcon field="NoOf_Benficiary"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                        <td>{{product.Source_id}}</td>
                        <td>{{product?.District}}</td>
                        <td>{{product?.Constituency}}</td>
                        <td>{{product?.Application_recevied}}</td>
                        <td>{{product?.Area}}</td>
                        <td>{{product?.Approved}}</td>
                        <td>{{product?.Verified_Area_Count}}</td>
                        <td>{{product?.Incomplete}}</td>
                        <td>{{product?.Rejected}}</td>
                        <td>{{product?.Pending}}</td>
                        <td>{{product?.Estimate_Created}}</td>
                        <td>{{product?.Estimate_Approved}}</td>
                        <td>{{product?.Billsof_Quantity_Uploaded}}</td>
                        <td>{{product?.Physical_Verification_Completed}}</td>
                        <td>{{product?.Assistance_Disbursed}}</td>
                        <td>{{product?.Assistance_Disbursed_Area}}</td>
                        <td>{{product?.Assistance_Disbursed_Amount}}</td>
                        <td>{{product?.NoOf_Benficiary}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex  justify-content-between flex-column ">
                        <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{disctrictConsistenceWiseData ?
                            disctrictConsistenceWiseData.length : 0 }} {{'VERIFICATION_APPLICATIONS_ADDED'| translate}}.
                        </p>
                    </div>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>